import { library as faLibrary, dom } from '@fortawesome/fontawesome-svg-core';
import {
    faTwitterSquare,
    faFacebook,
} from '@fortawesome/free-brands-svg-icons'

import * as fas  from '@fortawesome/free-solid-svg-icons';
import * as far from '@fortawesome/free-regular-svg-icons';

faLibrary.add([
    fas.faMobile,
    fas.faHeart,
    fas.faCopy,
    fas.faEllipsisH,
    fas.faQrcode,
    fas.faCompressAlt,
    fas.faSitemap,
    fas.faWindowClose,
    fas.faLongArrowAltLeft,
    fas.faPlus,
    fas.faFolderPlus,
    far.faFolder,
    fas.faCheck,
    fas.faExclamationCircle,
    fas.faHandshake,
    fas.faInfoCircle
]);

faLibrary.add([
    faTwitterSquare,
    faFacebook
]);

// Watch the DOM for icons added outside of vue templating (such as toasts)
dom.watch();
